import Head from 'next/head'

import PageNotFound from 'ui/page-not-found/PageNotFound'
import { I18nProvider } from '@elo-kit/components/i18n/i18n'

export default function NotFoundPage(props: { locale: string }) {
  return (
    <I18nProvider locale={props.locale}>
      <Head>
        <title>ablefy | 404</title>
      </Head>
      <PageNotFound hideGoBack />
    </I18nProvider>
  )
}

export function getStaticProps(context) {
  return Promise.resolve({
    props: { isErrorPage: true, locale: context.locale },
  })
}
